import { authFetch, BASE_BACKEND_URL } from '../../../auth'

const SENSITIVE_REQUEST = { redirect: 'manual' }

async function handleResponse(response) {
  if (response.status >= 300 && response.status < 400) {
    throw new Error('Error en la solicitud')
  }

  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    throw new Error(data.error || data.message || data.reason || 'Error en la solicitud')
  }
  return data
}

export async function fetchMyProfile() {
  const response = await authFetch(`${BASE_BACKEND_URL}/users/me`)
  if (!response) throw new Error('No autorizado')
  return handleResponse(response)
}

export async function updateMyProfile({ name, phone }) {
  const response = await authFetch(`${BASE_BACKEND_URL}/users/me`, {
    method: 'PUT',
    body: JSON.stringify({
      name,
      phone
    })
  })
  if (!response) throw new Error('No autorizado')
  return handleResponse(response)
}

export async function fetchSecurityStatus() {
  const response = await authFetch(`${BASE_BACKEND_URL}/users/me/security`)
  if (!response) throw new Error('No autorizado')
  return handleResponse(response)
}

export async function updateMyPassword({ currentPassword, password, passwordConfirmation, code }) {
  const response = await authFetch(`${BASE_BACKEND_URL}/users/me/password`, {
    method: 'PUT',
    ...SENSITIVE_REQUEST,
    body: JSON.stringify({
      current_password: currentPassword,
      password,
      password_confirmation: passwordConfirmation,
      code
    })
  })
  if (!response) throw new Error('No autorizado')
  return handleResponse(response)
}

export async function requestMyPasswordChangeCode() {
  const response = await authFetch(`${BASE_BACKEND_URL}/users/me/password/code`, {
    method: 'POST'
  })
  if (!response) throw new Error('No autorizado')
  return handleResponse(response)
}

export async function requestMyPasswordResetCode(email) {
  const response = await fetch(`${BASE_BACKEND_URL}/users/password`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email })
  })
  return handleResponse(response)
}

export async function verifyMyPasswordResetCode({ email, code }) {
  const response = await fetch(`${BASE_BACKEND_URL}/users/password/verify`, {
    method: 'POST',
    ...SENSITIVE_REQUEST,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email, code })
  })
  return handleResponse(response)
}

export async function resetMyPasswordWithToken({
  resetPasswordToken,
  password,
  passwordConfirmation
}) {
  const response = await fetch(`${BASE_BACKEND_URL}/users/password`, {
    method: 'PUT',
    ...SENSITIVE_REQUEST,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      reset_password_token: resetPasswordToken,
      password,
      password_confirmation: passwordConfirmation
    })
  })
  return handleResponse(response)
}

export async function setupMfa() {
  const response = await authFetch(`${BASE_BACKEND_URL}/users/me/mfa/setup`, { method: 'POST' })
  if (!response) throw new Error('No autorizado')
  return handleResponse(response)
}

export async function confirmMfa(code) {
  const response = await authFetch(`${BASE_BACKEND_URL}/users/me/mfa/confirm`, {
    method: 'POST',
    ...SENSITIVE_REQUEST,
    body: JSON.stringify({ code })
  })
  if (!response) throw new Error('No autorizado')
  return handleResponse(response)
}

export async function reconfigureMfa({ currentPassword, code }) {
  const response = await authFetch(`${BASE_BACKEND_URL}/users/me/mfa/reconfigure`, {
    method: 'POST',
    ...SENSITIVE_REQUEST,
    body: JSON.stringify({
      current_password: currentPassword,
      code
    })
  })
  if (!response) throw new Error('No autorizado')
  return handleResponse(response)
}

export async function disableMfa({ currentPassword, code }) {
  const response = await authFetch(`${BASE_BACKEND_URL}/users/me/mfa`, {
    method: 'DELETE',
    ...SENSITIVE_REQUEST,
    body: JSON.stringify({
      current_password: currentPassword,
      code
    })
  })
  if (!response) throw new Error('No autorizado')
  return handleResponse(response)
}

export async function regenerateBackupCodes({ currentPassword, code }) {
  const response = await authFetch(`${BASE_BACKEND_URL}/users/me/mfa/backup_codes/regenerate`, {
    method: 'POST',
    ...SENSITIVE_REQUEST,
    body: JSON.stringify({
      current_password: currentPassword,
      code
    })
  })
  if (!response) throw new Error('No autorizado')
  return handleResponse(response)
}
